require('./join-call/join-call.module');
require('./dashboard/dashboard.module');
require('./line-settings/line-settings.module');
require('./profile/profile.module');
require('./call-records/call-records.module');
require('./plans-billings/plans-billings.module');
require('./users/users.module');
require('./brand-settings/brand-settings.module');
require('./view-screenshare/view-screenshare.module');
require('./impersonate/impersonate.module');
require('./troubleshoot/troubleshoot.module');
require('./stream-listen/stream-listen.module');

angular.module('bbl.modules', [
  'bbl.module.dashboard',
	'bbl.module.joinCall',
	'bbl.module.line-settings',
	'bbl.module.profile',
	'bbl.module.call-records',
	'bbl.module.plans-billings',
	'bbl.module.users',
	'bbl.module.brand-settings',
	'bbl.module.view-screenshare',
  'bbl.module.impersonate',
	'bbl.module.troubleshoot',
	'bbl.module.streamListen',
]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/index.js
 ** module id = 315
 ** module chunks = 0
 **/